import { useInvadersHero } from "../../hooks/useInvadersHero";
import {
  HERO_LANDSCAPE,
  HERO_PORTRAIT,
} from "../../projects/space_invaders/presets/hero";
import { exitFullScreenIcon, fullScreenIcon, restartIcon } from "../../utils/icons";

export interface HeroLabels {
  hint: string;
  fullscreen: string;
  exitFullscreen: string;
  reset: string;
}

interface SpaceInvadersHeroProps {
  title: string;
  description: string;
  location: string;
  flag: string;
  labels: HeroLabels;
  /** Phones get the stacked word and demo-only playback. */
  portrait?: boolean;
}

const SpaceInvadersHero = (props: SpaceInvadersHeroProps) => {
  const { title, description, location, flag, labels, portrait = false } = props;
  const hero = useInvadersHero({
    config: portrait ? HERO_PORTRAIT : HERO_LANDSCAPE,
    interactive: !portrait,
  });

  return (
    <div
      className="hero-wrapper hero-wrapper--game"
      ref={hero.containerRef}
      tabIndex={-1}
      onPointerDown={hero.takeControl}
    >
      {/* The bunkers spell the name on the canvas; the heading carries it for
          crawlers and screen readers. */}
      <h1 className="visually-hidden">{title}</h1>
      <canvas className="hero-game-canvas" ref={hero.canvasRef} aria-hidden="true" />
      <p className="location-text">{location}</p>
      <div className="hero-content hero-content--game">
        <p>{description}</p>
        <img className="flag-img" src={flag} alt="ecuadorian" />
      </div>
      {hero.mode !== "manual" && !portrait && (
        <p className="hero-game-hint">{labels.hint}</p>
      )}
      {hero.mode === "manual" && (
        <div className="hero-game-controls">
          {hero.canFullscreen && (
            <button
              type="button"
              className="hero-game-button"
              onClick={hero.toggleFullscreen}
            >
              {hero.isFullscreen ? (exitFullScreenIcon) : (fullScreenIcon)}
            </button>
          )}
          <button type="button" className="hero-game-button" onClick={hero.reset}>
            {restartIcon}
          </button>
        </div>
      )}
    </div>
  );
};

export default SpaceInvadersHero;
